import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { ErrorResponse } from "../../models/apiResponse";
import { Customer } from "../../models/Service";

const useQueryCustomer = ({
  customerCode,
  corporateId,
  enabled = false,
  authorisation = "",
}: {
  customerCode: string;
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/customer/${customerCode}`],
    () =>
      httpClient(
        `corporate-subsidiary/${corporateId}/customer/${customerCode}`,
        { authorisation }
      ).get<Customer | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 1,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryCustomer;
